(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('HospitalizationTypeDialogController', HospitalizationTypeDialogController);

    HospitalizationTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HospitalizationType', 'HospitalizationTypeParent'];

    function HospitalizationTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HospitalizationType, HospitalizationTypeParent) {
        var vm = this;
        vm.hospitalizationType = entity;
        vm.hospitalizationtypeparents = HospitalizationTypeParent.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:hospitalizationTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.hospitalizationType.id !== null) {
                HospitalizationType.update(vm.hospitalizationType, onSaveSuccess, onSaveError);
            } else {
                HospitalizationType.save(vm.hospitalizationType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
